var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBackToTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 41,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1D1D1B",
  strokeWidth: 2,
  d: "m9.598 24.638 10.804-10.805 10.804 10.805"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  x: 0.5,
  y: 39.735,
  stroke: "#000",
  rx: 19.5,
  transform: "rotate(-90 .5 39.735)"
})));
export default SvgBackToTop;